var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.966 5.507 9.566 3.105A.357.357 0 0 0 9.313 3H4.57a.357.357 0 0 0-.357.357v9.286c0 .197.16.357.357.357h7.143c.198 0 .357-.16.357-.357V5.76a.359.359 0 0 0-.104-.253zm-.718.417h-2.1v-2.1l2.1 2.1zm.02 6.272h-6.25V3.804h3.37v2.41a.469.469 0 0 0 .47.469h2.41v5.513z",
    fill: "#323234",
    stroke: "#000",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.944e6c4c616d69de6594edf92c3922b0.svg";
export { ForwardRef as ReactComponent };